import React from "react"

import "./index.scss"

const Feedback = ({ message }) => {
  return <div className="form-invalid">{message}</div>
}

export default Feedback
